var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSortableIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 7.914,
    height: 10.657,
    viewBox: "0 0 7.914 10.657",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-384.082 -512.115)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.746.128A.356.356,0,0,0,6.2.585.36.36,0,0,0,6.244.63l2.8,2.952c.039.013-.075.025,0,0L6.24,6.471a.364.364,0,0,0,0,.5.354.354,0,0,0,.5,0h0L9.916,3.8a.348.348,0,0,0,.009-.493L9.916,3.3Z",
    transform: "translate(384.5 522.513) rotate(-90)",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.746.128A.356.356,0,0,0,6.2.585.36.36,0,0,0,6.244.63l2.8,2.952c.039.013-.075.025,0,0L6.24,6.471a.364.364,0,0,0,0,.5.354.354,0,0,0,.5,0h0L9.916,3.8a.348.348,0,0,0,.009-.493L9.916,3.3Z",
    transform: "translate(391.577 512.374) rotate(90)",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.75
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSortableIcon);
export default __webpack_public_path__ + "static/media/sortable_icon.1eab66a893097ac44c441a06dff902da.svg";
export { ForwardRef as ReactComponent };